module.exports = __webpack_public_path__ + "img/shopify.81a2705b.png";